import React from 'react'
import Typography, { TypographyProps } from '@material-ui/core/Typography'
import styled from 'styled-components'

interface IH3Prop {
  children: any
  mt?: number
  mr?: number
  mb?: number
  ml?: number
}

const step = 4

const getMargin = (param: number | boolean | undefined): number => {
  if (!param) {
    return 0
  }
  return typeof param === 'number' ? param * step : step
}

const margin = ({ mt, mr, mb, ml }: IH3Prop) =>
  `${getMargin(mt)}px ${getMargin(mr)}px ${getMargin(mb)}px ${getMargin(ml)}px`

const StyledTypography = styled(Typography)`
  margin: ${(props: IH3Prop) => margin(props)};
`

export const H3 = ({ children, ...props }: TypographyProps & IH3Prop) => (
  <StyledTypography variant="h3" {...props}>
    {children}
  </StyledTypography>
)
